// extracted by mini-css-extract-plugin
export default {"cls1":"UserTooltip-cls1__Er","cls2":"UserTooltip-cls2__Hg UserTooltip-cls1__Er"};